import { useContext, useEffect, useState } from "react";
import "./style.css";
import { GanttChartContainer } from "./GanttChartContainer";
import Spin from "../../../components/controls/spinner/Spin";
import { ResourceMoniteringContext } from "../../resourcePlanner/resourceMonitoring/ResourceContext";

const ViewTypes = {
  Month: "monthly",
  Quarter: "quarter",
  Week: "weekly",
  Day: "daily",
};

export const GanttChart = ({
  viewType,
  showTaskModal,
  setTaskStartDate,
  isHideScope,
  isHideTask,
  displayType,
  baseLine,
  critical,
  handleEditTaskModal,
  count,
  setScopeItem,
  overviewType,
  isHeaderCollapsed = false
}) => {
  const { scopes, setScopes, isInitialTimelineLoading } = useContext(
    ResourceMoniteringContext
  );
  const [expandedScopes, setExpandedScopes] = useState({});
  const [expandedTaskGroups, setExpandedTaskGroups] = useState({});
  useEffect(() => {
    if (scopes && scopes.length > 0) {
      setExpandedScopes(() =>
        scopes.reduce((acc, scope) => ({ ...acc, [scope.id]: true }), {})
      );
      setExpandedTaskGroups(() =>
        scopes.reduce(
          (acc, scope) => ({
            ...acc,
            ...(scope.taskGroups || []).reduce(
              (groupAcc, group) => ({ ...groupAcc, [group.id]: true }),
              {}
            ),
          }),
          {}
        )
      );
    }
  }, [scopes]);

  const toggleScope = (scopeId) => {
    setExpandedScopes((prev) => ({
      ...prev,
      [scopeId]: !prev[scopeId],
    }));
  };

  const toggleTaskGroup = (taskGroupId) => {
    setExpandedTaskGroups((prev) => ({
      ...prev,
      [taskGroupId]: !prev[taskGroupId],
    }));
  };

  if (isInitialTimelineLoading) {
    return (
      <div
        className="w-full flex items-center justify-center"
        style={{
          height:
            overviewType === "Project"
              ? `calc(100vh - ${isHeaderCollapsed ? '268px' : '420px'})`
              : `calc(100vh - 211px)`,
        }}
      >
        <Spin />
      </div>
    );
  }

  return (
    <GanttChartContainer
      scopes={scopes}
      setScopes={setScopes}
      expandedScopes={expandedScopes}
      toggleScope={toggleScope}
      expandedTaskGroups={expandedTaskGroups}
      toggleTaskGroup={toggleTaskGroup}
      viewType={ViewTypes[viewType]}
      viewTypeKey={viewType}
      showTaskModal={showTaskModal}
      setTaskStartDate={setTaskStartDate}
      isHideScope={isHideScope}
      isHideTask={isHideTask}
      displayType={true}
      handleTaskModal={handleEditTaskModal}
      critical={critical}
      count={count}
      setScopeItem={setScopeItem}
      overviewType={overviewType}
      isHeaderCollapsed={isHeaderCollapsed}
    />
  );
};
